
import children from '../../dom/modules/children.js';
import select   from '../../dom/modules/select.js';
import { isTextNode } from '../../dom/modules/node.js';

// Create ghost elements to enable us to give the impression of a continuous
// loop.

select('.ticker-block > .ticker-text', document.body).forEach((element) => {
    // Strip text nodes. We need the added to content to exactly double the
    // width of its container
    element.childNodes.forEach((node) => isTextNode(node) && node.remove());

    // Create a couple of extra sets of content nodes
    const nodes = children(element);
    let n = 2;
    while(n--) {
        element.append.apply(element, nodes.map((child) => {
            const clone = child.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            return clone;
        }));
    }
});

// Play/pause state is handled entirely in CSS.
